module.exports = require("./sr-Latn-BA.d.ts");